$(document).ready(function () {
  // enable/disable image replacement ( this flag could be set dynamically in liquid based on product tags or any other indicator )
  window.uploadLiftReplace = true;

  // class names based on newer debut theme version
  var classSingleImage = ".product-single__media";
  var classFeaturedImage = ".product-featured-media";

  // for older debut themes uncomment:
  // var classSingleImage = '.product-single__photo';
  // var classFeaturedImage = '.product-featured-img';

  if (window.uploadLiftReplace) {
    var productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm != null) {
      // find the product image
      var $productSingleImage = $(classSingleImage);
      var zoomEnabled = $productSingleImage.hasClass("js-zoom-enabled");

      var $productImage;
      var $uploadedImage;

      // subscribe to upload:added event
      productForm.addEventListener("upload:added", function (e) {
        var file = e.detail;

        // show the thumbnail variant
        if (file.url && file.meta.variant === "thumbnail") {
          if (!$uploadedImage) {
            // single image centered
            $uploadedImage = $(
              '<img style="position: absolute;left:0;right:0;top:0;margin: auto;max-height: 100%;">'
            );
          }

          $uploadedImage.attr("src", file.url);

          if (!$productImage) {
            $productImage = $productSingleImage.find(classFeaturedImage);
            $productImage.replaceWith($uploadedImage);

            // disable zoom ( does not make much sense with the uploaded thumbnail )
            if (zoomEnabled) {
              $productSingleImage.trigger("zoom.destroy");
            }
          }
        }
      });

      // subscribe to upload:removed event
      productForm.addEventListener("upload:removed", function (e) {
        var file = e.detail;

        if ($productImage && $uploadedImage) {
          // check if the current displayed image was removed
          if ($uploadedImage.attr("src") == file.url) {
            $uploadedImage.replaceWith($productImage);

            // reset to trigger replace on the next upload
            $productImage = null;

            // re enable zoom
            if (zoomEnabled) {
              $productSingleImage.zoom({
                url: $productSingleImage.data("zoom"),
              });
            }
          }
        }
      });
    }
  }
});
